import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from "react";
import { linkClassNames } from "common/components/Footer";
export const Link = t0 => {
  "use memo";

  const $ = _c(4);
  const {
    href,
    title,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== href || $[2] !== title) {
    t1 = <a title={title} href={href} className={linkClassNames}>{children}</a>;
    $[0] = children;
    $[1] = href;
    $[2] = title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};